module.exports = __webpack_public_path__ + "img/status_failed.3cc1f0d9.png";